import {createSvgIcon} from '../create-svg-icon';

export const AlignHorizontalCenterIcon = createSvgIcon(
  <path d="M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8z" />
, 'AlignHorizontalCenterOutlined');
